import React from "react";
import "./Tabs.scss";
import { TabsProps } from "./Tabs.types";

const Tabs = ({ tabList }: TabsProps) => {
  const [list, setList] = React.useState(tabList);

  const onTabClick = (tabIndex: number) => {
    const previousList = list.map((item, index) => ({
      ...item,
      isActive: tabIndex === index,
    }));
    setList(previousList);
  };

  return (
    <div className="tab-wrapper">
      <div className="tab">
        {list.map((tab, index) => (
          <div
            key={tab.label}
            className={tab.isActive ? "tab-label active" : "tab-label"}
            aria-hidden="true"
            onClick={() => onTabClick(index)}
          >
            {tab.label}
          </div>
        ))}
      </div>
      {list
        .filter((item) => item.isActive)
        .map((tab, index) => (
          <div className="tab-body">{tab.section}</div>
        ))}
    </div>
  );
};

export default Tabs;
